import { useEffect, useState, useCallback } from "react";
import { FaSearch, FaSpinner, FaKey } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./ManageAdmins.css";
import UserPermissionsPanel from "../components/UserPermissionsPanel";

const API_URL = process.env.REACT_APP_API_URL;

const ROLE_LABELS = { admin: "Admin", user: "User" };

function UserPermissions() {

    const [accounts, setAccounts] = useState([]);

    const [filtered, setFiltered] = useState([]);

    const [search, setSearch] = useState("");

    const [isLoading, setIsLoading] = useState(true);

    const [permissionsFor, setPermissionsFor] = useState(null);

    const load = useCallback(async () => {

        setIsLoading(true);

        try {

            const res = await fetch(`${API_URL}/portal/permissions/accounts`);

            const data = await res.json();

            if (data.status) {

                setAccounts(data.data || []);

            } else {

                setAccounts([]);

                toast.error(data.message || "Failed to load accounts.");

            }

        } catch (err) {

            console.error("Failed to load accounts:", err);

            toast.error("Unable to load accounts.");

        } finally {

            setIsLoading(false);

        }

    }, []);

    useEffect(() => {

        load();

    }, [load]);

    useEffect(() => {

        const value = search.toLowerCase();

        setFiltered(

            accounts.filter(a =>
                a.username.toLowerCase().includes(value) ||
                (a.first_name || "").toLowerCase().includes(value) ||
                (a.last_name || "").toLowerCase().includes(value) ||
                ROLE_LABELS[a.role]?.toLowerCase().includes(value)
            )

        );

    }, [search, accounts]);

    return (

        <div className="page">

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
            />

            <div className="page-header">

                <div>
                    <h2>User Permissions</h2>
                   {/*  <p className="page-subtitle">
                        Pick an account below to give it its own custom menu permissions,
                        independent of its role's default. SuperAdmin sees every Admin and User
                        account; Admins only see the User accounts they personally created.
                        (The role-wide defaults themselves are set under Role Permissions,
                        SuperAdmin only.)
                    </p> */}
                </div>

            </div>

            {

                permissionsFor ? (

                    <UserPermissionsPanel
                        userId={permissionsFor.id}
                        username={permissionsFor.username}
                        onClose={() => setPermissionsFor(null)}
                    />

                ) : (

                    <>

                        <div className="search-box">

                            <FaSearch />

                            <input
                                placeholder="Search by username, name, or role..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />

                        </div>

                        <div className="table-container">

                            <table>

                                <thead>

                                    <tr>
                                        <th>Username</th>
                                        <th>Name</th>
                                        <th>Role</th>
                                        <th>Status</th>
                                        <th style={{ width: "100px" }}>Action</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {

                                        isLoading ?

                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "40px" }}>
                                                    <FaSpinner className="spin" /> Loading accounts...
                                                </td>
                                            </tr>

                                            :

                                            filtered.length === 0 ?

                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: "center", padding: "40px" }}>
                                                        No accounts found.
                                                    </td>
                                                </tr>

                                                :

                                                filtered.map(a => (

                                                    <tr key={`${a.role}-${a.id}`}>

                                                        <td>{a.username}</td>

                                                        <td>{[a.first_name, a.last_name].filter(Boolean).join(" ") || "-"}</td>

                                                        <td>{ROLE_LABELS[a.role] || a.role}</td>

                                                        <td>
                                                            <span className={`status-pill ${a.is_active ? "active" : "inactive"}`}>
                                                                {a.is_active ? "Active" : "Inactive"}
                                                            </span>
                                                        </td>

                                                        <td>

                                                            <div className="action-buttons">

                                                                <button
                                                                    type="button"
                                                                    className="icon-btn perm-btn"
                                                                    title="Custom permissions"
                                                                    aria-label="Custom permissions"
                                                                    onClick={() => setPermissionsFor({ id: a.id, username: a.username })}
                                                                >
                                                                    <FaKey />
                                                                </button>

                                                            </div>

                                                        </td>

                                                    </tr>

                                                ))

                                    }

                                </tbody>

                            </table>

                        </div>

                    </>

                )

            }

        </div>

    );

}

export default UserPermissions;
